// Copyright (c) Laserfiche.
// Licensed under the MIT License. See LICENSE in the project root for license information.

import { Component } from '@angular/core';
import { ExampleUsageBasicStepsDirective } from '../example-usage-basic-steps.directive';

@Component({
  selector: 'app-example-npm-usage-in-angular',
  templateUrl: './example-npm-usage-in-angular.component.html',
  styleUrls: ['./example-npm-usage-in-angular.component.css', '../app.component.css'],
  standalone: true,
  imports: [],
})
export class ExampleNpmUsageInAngularComponent extends ExampleUsageBasicStepsDirective {}
